module.exports = __webpack_public_path__ + "static/media/skimage.846febc9.png";